import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Path } from 'src/app/app-routing.module';

import {
  APP_CONF_PATH,
  CommonActivityMonitoringFeatureForRootModule,
  CommonBasketFeatureForRootModule,
  CommonChannelMailVendorEpticaForRootModule,
  CommonCoreFeatureForRootModule,
  CommonMetricFeatureForRootModule,
  CommonRouterFeatureForRootModule,
  CommonTransportMessagingVendorCometdForRootModule,
  EPTICA_STRATEGY,
  EpticaTokenInterceptor,
  LIB_PHONE_CONF_PATH,
  LoginFeatureCoreForRootModule,
  MailDefaultStateStrategyType,
  PortalFeatureCoreForRootModule,
  TilesAgentFeatureCoreForRootModule,
  TRANSLATION_NS,
} from '@contact/upgrade';

import { AJS_PROVIDERS } from './core.provider.ajs';
import { EpticaFrameIntegrationService } from './mail/eptica-frame-integration.service';
import { EmptyInterceptor } from './transport/empty.interceptor';

@NgModule({
  imports: [
    CommonRouterFeatureForRootModule.instance(),
    CommonCoreFeatureForRootModule.instance({
      pathToAppConf: APP_CONF_PATH,
      pathToLibPhoneConf: LIB_PHONE_CONF_PATH,
      loginPath: Path.login,
      portalPath: Path.portal,
      phoneNumberFormatDisable: true,
      material: {
        darkDialogEnabled: false,
      },
    }),
    CommonBasketFeatureForRootModule.instance(),
    CommonActivityMonitoringFeatureForRootModule.instance(),
    CommonChannelMailVendorEpticaForRootModule.instance(),
    CommonTransportMessagingVendorCometdForRootModule.instance(),
    CommonMetricFeatureForRootModule.instance(),
    LoginFeatureCoreForRootModule.instance(),
    PortalFeatureCoreForRootModule.instance(),
    TilesAgentFeatureCoreForRootModule.instance({
      pullStrategy: MailDefaultStateStrategyType.dependingOnChannel,
      pushStrategy: MailDefaultStateStrategyType.dependingOnChannel,
      phoneUnitAutoRequestedEnabled: true,
      acceptation: {
        acceptingByToastEnabled: false,
      },
    }),
  ],
})
export class CoreForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreForRootModule) {
    if (parentModule) throw new Error(`[CoreForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<CoreForRootModule> {
    return {
      ngModule: CoreForRootModule,
      providers: [
        AJS_PROVIDERS,

        /**
         * No need to insert token in url
         * because the frame create a cookie with the token
         */
        {
          provide: EpticaTokenInterceptor,
          useExisting: EmptyInterceptor,
        },
        {
          provide: EPTICA_STRATEGY,
          useExisting: EpticaFrameIntegrationService,
        },

        {
          provide: TRANSLATION_NS,
          useValue: 'commons',
          multi: true,
        },
      ],
    };
  }
}
